import { define, Model, AttributesMixin } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { SortOptions, matchString, isFeatureEnabled } from "./common";

export interface ExpiredQuote extends AttributesMixin<typeof ExpiredQuote> { }

@define
/**
 * Expired Quotes edpoint
 */
export class ExpiredQuote extends Model {
    static endpoint = restfulIO('/api/v1/po/expired');
    static idAttribute = 'quote_id';

    static attributes = {
        quote_id: String,
        quote_date: Date,
        expiry_date: Date
    }

    public static getFeatureEnabledEndpoint() {
        return isFeatureEnabled("enableOmApi") ? restfulIO("/api/v3/po/expired") : restfulIO("/api/v1/po/expired");
    }

    public getEndpoint() {
        return isFeatureEnabled("enableOmApi") ? restfulIO("/api/v3/po/expired") : restfulIO("/api/v1/po/expired");
    }

    static sortBy = {
        expiry_date: 'Expired On',
        quote_date: 'Created On',
        quote_id: 'Quote ID'
    }

    static createFilter(category: any, filter: string, sort: SortOptions) {
        return x => !filter || filter.length < 2
            || matchString(x.quote_id, filter)
            || matchString(x.quote_date.toDateString(), filter)
            || matchString(x.expiry_date.toDateString(), filter)
    }
}